import type { InvalidLicenseStatus } from '@directus/license';

export const LICENSE_INVALID_REASONS = ['expired', 'suspended', 'canceled'] as const satisfies readonly InvalidLicenseStatus[];

export const LICENSE_SOURCES = ['env-key', 'env-token'] as const;

export const LICENSE_SERVER_STATUSES = ['reachable', 'unreachable'] as const;

export const LICENSE_LIMIT_GATES = ['hard', 'soft', 'none'] as const;

export const LICENSE_LIMIT_STATUSES = ['allow', 'warn', 'block'] as const;
